import { Switch } from 'antd';
import { OPTIONS_DEFAULTS } from '../communication-compose/communication-compose.schema';
import styles from '../communication-compose/communication-compose.module.scss';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { useTotalRecipients } from '../recipients-group-selector/total-recipients.context';
import { LearnMore } from 'src/components/common/learn-more';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTriangleExclamation, faEllipsisVertical } from '@fortawesome/pro-regular-svg-icons';
import { colorPalette } from 'shared/constants';
import { IconButton } from 'src/components/design-system';
import { useEffect } from 'react';
import { isWorkingHoursNow } from 'shared/store/selectors/organization.selector';

const MAX_RECIPIENTS = 1000;

export function NotificationOptionsToggles({ setOptionsCheckboxState, values }) {
  const lang = useSelector(getLang('COMMUNICATION_CENTER'));
  const isWorkHoursNow = useSelector(isWorkingHoursNow);
  const organizationStartWorkingHours = useSelector(
    ({ organization }) => organization?.workingHoursStartTime || 7,
  );

  const { recipients } = useTotalRecipients();

  useEffect(() => {
    if (recipients.length >= MAX_RECIPIENTS) {
      setOptionsCheckboxState('sendByEmail')(false);
    } else {
      setOptionsCheckboxState('sendByEmail')(OPTIONS_DEFAULTS.sendByEmail);
    }
    // eslint-disable-next-line
  }, [recipients]);

  return (
    <>
      {!isWorkHoursNow && (
        <>
          <div className={styles.toggleWrapper}>
            <Switch
              size="medium"
              defaultChecked={OPTIONS_DEFAULTS.onWorkingHours}
              checked={values.options.onWorkingHours}
              onChange={setOptionsCheckboxState('onWorkingHours')}
            />
            <p className={styles.checkLabel}>
              {lang.ON_WORKING_HOURS.replace('{START_HOUR}', organizationStartWorkingHours)}
            </p>
          </div>
          <FontAwesomeIcon icon={faEllipsisVertical} size="xl" color={colorPalette.neutral5} />
        </>
      )}
      <div className={styles.toggleWrapper}>
        {recipients.length >= MAX_RECIPIENTS && (
          <IconButton label={lang.MAX_LIMIT_RECIPIENTS}>
            <FontAwesomeIcon
              icon={faTriangleExclamation}
              color={colorPalette.redMedium}
              size="lg"
            />
          </IconButton>
        )}

        <Switch
          size="medium"
          disabled={recipients.length >= MAX_RECIPIENTS}
          defaultChecked={OPTIONS_DEFAULTS.sendByEmail}
          checked={values.options.sendByEmail}
          onChange={setOptionsCheckboxState('sendByEmail')}
        />
        <p className={styles.checkLabel}>{lang.SEND_BY_EMAIL}</p>

        <LearnMore
          link="https://portal.help.c8health.com/servicedesk/customer/kb/view/1418363061"
          text={lang.LEARN_MORE_SEND_EMAIL}
        />
      </div>
    </>
  );
}
